import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';
import { EcomsyncBranchLabelHdrLinkContainerModel } from '../../../../../../models/aggregates/erp/ecomsync-branch/index';

@Injectable({
  providedIn: 'root'
})
export class EcomsyncBranchLabelHdrLinkService extends BaseApiTemplateService<EcomsyncBranchLabelHdrLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'branch-label-hdr-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'branch-label-hdr-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'branch-label-hdr-links';
    this.httpClient = http;
  }

  public postQuery(
    visa: ApiVisa,
    fi_branch_guid: string,
    label_list_hdr_guid: string,
    label_hdr_guid: string,
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/label-link?fi_branch_guid=' + fi_branch_guid + '&label_list_hdr_guids=' + label_list_hdr_guid + '&label_hdr_guids=' + label_hdr_guid;
    }
    const url = this.apiUrl;
    return this.httpClient.post<PagingResponseModel<any>>(
      url,
      null,
      this.getHttpHeaderJson(visa)
    );
  }
}

